<script setup lang="ts">
import type { ScenePage } from '~/models/Presentation/Pages/ScenePage.js'
import type { BasePageProps } from '~/models/Presentation/BasePage'
import type { ContentScene } from '~/models/Content/ContentScene.js'
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { Subtree } from '~/models/Content/Subtree.js'
import { ContentType } from '~/models/Content/ContentType.js'
import { ColorName } from '~/models/Content/Color.js'
import { useMonoColorTheme } from '~/composables/useColorTheme.js'
import useContentApi from '~/api/contentApi'
import Scene from '~/components/scene/Scene.vue'

const props = defineProps<BasePageProps & { page: ScenePage }>()
const { findContents } = useContentApi()
const contentId = computed(() => props.page.scene.destinationContentId)
const scene = useQuery({
  queryKey: ['scene', contentId],
  staleTime: Infinity,
  async queryFn() {
    const [content] = await findContents<ContentScene>({
      contentTypeCriterion: [ContentType.Scene],
      subtreeCriterion: [Subtree.Content, Subtree.Media],
      contentIdCriterion: [Number(contentId.value)],
      mainLocationCriterion: true,
    })

    return content
  }
})
const theme = useMonoColorTheme(ColorName.Green5)
</script>

<template>
  <div
    class="grid"
    :style="{
      background: page.colorPair.background,
      color: page.colorPair.text,
      ...theme.style.value,
    }"
  >
    <Scene
      v-if="scene.data.value"
      class="h-screen w-full p-6"
      :content="scene.data.value"
    />
  </div>
</template>
